module.exports = __webpack_public_path__ + "img/icon2.5794cbb0.svg";